import React from 'react';
import { DataProvider } from '../providers/dataProvider';
import { PopUpProvider } from '../providers/popUpProvider';
import Popup from './Popup';
import Table from "./Table";
import lc from "../cmprtbl.module.scss";

function App() {
    return (
        <PopUpProvider>
            <DataProvider>
                <div className={ lc.table_container }>
                    <Table />
                </div>
                <Popup />  
            </DataProvider>
        </PopUpProvider>
    );
}

export default App;
